export default __webpack_public_path__ + "static/media/rocket_anim_93.81316d6f.png";